/*
  Portail client — connexion et boutique privée.

  Vanilla, sans dépendance, comme updn-motion.js.

  Ce fichier ne décide de RIEN sur la sécurité. Il n'a aucun mot de passe,
  aucune liste d'organisations, aucun produit. Il pose des questions au serveur
  et affiche les réponses. Tout ce qu'il cache à l'écran, le serveur l'a déjà
  refusé de son côté — c'est pourquoi il n'y a rien à gagner à trafiquer cette
  page depuis la console.

  Le jeton vit en sessionStorage et non dans un témoin : l'App Proxy Shopify
  retire les en-têtes Cookie et Set-Cookie, une session par témoin est donc
  impossible sous /apps/*. sessionStorage se vide à la fermeture de l'onglet,
  ce qui convient à un poste partagé — un ordinateur de bibliothèque d'école,
  par exemple.
*/
(function () {
  'use strict';

  var CLE_JETON = 'updn_portail_jeton';
  var CLE_SLUG = 'updn_portail_slug';

  // ── Petits utilitaires ──

  function $(sel, racine) { return (racine || document).querySelector(sel); }

  function elem(balise, classe, texte) {
    var n = document.createElement(balise);
    if (classe) n.className = classe;
    if (texte != null) n.textContent = texte;
    return n;
  }

  /** Prix en cents ou en chaîne « 59.95 » → « 59,95 $ ». */
  function prix(valeur) {
    var n = Number(valeur);
    if (!isFinite(n)) return '';
    return n.toFixed(2).replace('.', ',') + ' $';
  }

  /**
   * sessionStorage peut lever — Safari en navigation privée, stockage plein.
   * Le portail doit alors fonctionner le temps de la visite, pas s'arrêter.
   */
  var memoire = {};
  function lire(cle) {
    try { return sessionStorage.getItem(cle); } catch (e) { return memoire[cle] || null; }
  }
  function ecrire(cle, valeur) {
    try { sessionStorage.setItem(cle, valeur); } catch (e) { memoire[cle] = valeur; }
  }
  function oublier(cle) {
    try { sessionStorage.removeItem(cle); } catch (e) { /* rien */ }
    delete memoire[cle];
  }

  // ── Initialisation ──

  function demarrer(racine) {
    if (!racine || racine.dataset.portailPret === '1') return;
    racine.dataset.portailPret = '1';

    var proxy = racine.dataset.proxy || '/apps/compte';
    var volPublic = $('[data-portail-public]', racine);
    var volPrive = $('[data-portail-prive]', racine);
    var form = $('[data-portail-form]', racine);
    var champErreur = $('[data-portail-erreur]', racine);
    var bouton = $('[data-portail-submit]', racine);
    var boutonTexte = $('[data-portail-submit-texte]', racine);

    /** Appel au back-end. Toujours POST : le corps ne passe pas dans l'URL. */
    function appeler(chemin, corps) {
      return fetch(proxy + '/boutique/' + chemin, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corps)
      }).then(function (r) {
        return r.json().then(
          function (d) { return { ok: r.ok, statut: r.status, donnees: d }; },
          // L'App Proxy remplace parfois la réponse par du HTML (page d'erreur
          // du thème). Ne pas laisser le JSON.parse remonter tel quel.
          function () { return { ok: false, statut: r.status, donnees: {} }; }
        );
      });
    }

    function erreur(message) {
      if (!champErreur) return;
      if (!message) { champErreur.hidden = true; champErreur.textContent = ''; return; }
      champErreur.textContent = message;
      champErreur.hidden = false;
    }

    function occupe(oui) {
      if (!bouton) return;
      bouton.disabled = oui;
      if (boutonTexte) boutonTexte.textContent = oui ? 'Vérification…' : 'Se connecter';
    }

    // ── Connexion ──

    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        erreur('');

        var identifiant = (form.elements.identifiant.value || '').trim();
        var motDePasse = form.elements.motDePasse.value || '';
        if (!identifiant || !motDePasse) {
          erreur('Entrez votre nom d’utilisateur et votre mot de passe.');
          return;
        }

        occupe(true);
        appeler('connexion', { identifiant: identifiant, motDePasse: motDePasse })
          .then(function (rep) {
            occupe(false);
            if (!rep.ok || !rep.donnees.jeton) {
              erreur(rep.donnees.erreur || 'La connexion a échoué. Réessayez.');
              return;
            }
            ecrire(CLE_JETON, rep.donnees.jeton);
            ecrire(CLE_SLUG, rep.donnees.boutique.slug);
            form.reset();
            ouvrirPortail(rep.donnees.boutique.slug);
          })
          .catch(function () {
            occupe(false);
            erreur('Connexion impossible. Vérifiez votre lien Internet et réessayez.');
          });
      });
    }

    function deconnecter() {
      oublier(CLE_JETON);
      oublier(CLE_SLUG);
      if (volPrive) { volPrive.hidden = true; volPrive.innerHTML = ''; }
      if (volPublic) volPublic.hidden = false;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // ── Chargement du portail ──

    function ouvrirPortail(slug) {
      var jeton = lire(CLE_JETON);
      if (!jeton || !slug) { deconnecter(); return; }

      if (volPublic) volPublic.hidden = true;
      if (volPrive) {
        volPrive.hidden = false;
        volPrive.innerHTML = '';
        volPrive.appendChild(elem('div', 'updn-portail__chargement', 'Chargement de votre boutique…'));
      }

      appeler('donnees', { jeton: jeton, slug: slug })
        .then(function (rep) {
          if (!rep.ok) {
            // Session expirée ou portail disparu : on ramène à la connexion avec
            // le motif, plutôt que de laisser un écran vide.
            deconnecter();
            erreur(rep.donnees.erreur || 'Votre session a expiré. Reconnectez-vous.');
            return;
          }
          supplement = rep.donnees.supplement || null;
          rendrePortail(rep.donnees.boutique, rep.donnees.produits || []);
        })
        .catch(function () {
          deconnecter();
          erreur('Chargement impossible. Réessayez dans quelques instants.');
        });
    }

    // ── Rendu ──

    function rendrePortail(boutique, produits) {
      if (!volPrive) return;
      volPrive.innerHTML = '';

      volPrive.appendChild(enTete(boutique));
      volPrive.appendChild(bandeau(boutique.fenetre));

      var section = elem('section', 'updn-section');
      var wrap = elem('div', 'updn-wrap');

      var commandable = boutique.fenetre.statut === 'ouverte';

      if (!produits.length) {
        wrap.appendChild(elem('p', 'updn-portail__vide',
          'Aucun article n’est offert dans ce portail pour le moment.'));
      } else {
        var grille = elem('div', 'updn-grille updn-grille--3 updn-portail__grille');
        produits.forEach(function (p) { grille.appendChild(carte(p, commandable)); });
        wrap.appendChild(grille);
      }

      var pied = elem('div', 'updn-portail__pied');
      var quitter = elem('button', 'updn-btn updn-btn--contour', 'Quitter le portail');
      quitter.type = 'button';
      quitter.addEventListener('click', deconnecter);
      pied.appendChild(quitter);
      wrap.appendChild(pied);

      section.appendChild(wrap);
      volPrive.appendChild(section);

      verifierPanierMixte(boutique);
    }

    function enTete(boutique) {
      var section = elem('section', 'updn-section updn-section--craie updn-portail__entete');
      var wrap = elem('div', 'updn-wrap updn-portail__entete-corps');

      if (boutique.logo) {
        var cadre = elem('div', 'updn-portail__logo');
        var img = document.createElement('img');
        img.src = boutique.logo;
        img.alt = boutique.nom;
        img.loading = 'eager';
        cadre.appendChild(img);
        wrap.appendChild(cadre);
      }

      var textes = elem('div', 'updn-portail__entete-textes');
      textes.appendChild(elem('h1', 'updn-portail__nom', boutique.nom));
      if (boutique.message) {
        textes.appendChild(elem('p', 'updn-portail__message', boutique.message));
      }
      wrap.appendChild(textes);
      section.appendChild(wrap);
      return section;
    }

    /** Bandeau de dates. Trois états, trois tons — jamais ambigu. */
    function bandeau(fenetre) {
      var etat = fenetre.statut;
      var mot;
      if (etat === 'ouverte') {
        var j = fenetre.joursRestants;
        if (j === 0) mot = 'Dernière journée pour commander';
        else if (j === 1) mot = 'Il reste 1 jour pour commander';
        else mot = 'Il reste ' + j + ' jours pour commander';
        mot += ' — jusqu’au ' + dateLongue(fenetre.fermeture);
      } else if (etat === 'a-venir') {
        mot = 'Cette boutique ouvrira prochainement — le ' + dateLongue(fenetre.ouverture);
      } else {
        mot = 'Cette boutique est maintenant fermée.';
      }

      var bloc = elem('div', 'updn-portail__bandeau updn-portail__bandeau--' + etat);
      var wrap = elem('div', 'updn-wrap updn-portail__bandeau-corps');
      wrap.appendChild(elem('span', 'updn-portail__bandeau-texte', mot));
      bloc.appendChild(wrap);
      // Le statut compte : il doit être annoncé, sans interrompre.
      bloc.setAttribute('role', 'status');
      return bloc;
    }

    var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',
                'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

    /** « 2026-09-30 » → « 30 septembre 2026 ». */
    function dateLongue(iso) {
      if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return '';
      var p = iso.split('-');
      // Pas de new Date(iso) : le navigateur lirait minuit UTC et afficherait la
      // veille pour tout le Québec. On formate les chiffres tels quels.
      return Number(p[2]) + ' ' + MOIS[Number(p[1]) - 1] + ' ' + p[0];
    }

    function carte(p, commandable) {
      var art = elem('article', 'updn-carte updn-portail__carte');

      var media = elem('div', 'updn-carte__media');
      if (p.image) {
        var img = document.createElement('img');
        // Vignette servie par le CDN Shopify : inutile de tirer l'original.
        img.src = p.image + (p.image.indexOf('?') === -1 ? '?' : '&') + 'width=800';
        img.alt = p.imageAlt || p.titre;
        img.loading = 'lazy';
        media.appendChild(img);
      }
      art.appendChild(media);

      var corps = elem('div', 'updn-carte__corps updn-portail__carte-corps');
      corps.appendChild(elem('h3', 'updn-carte__titre', p.titre));
      corps.appendChild(elem('p', 'updn-portail__prix', prix(p.prixMin)));

      var btn = elem('button', 'updn-btn updn-btn--plein updn-portail__commander',
        commandable ? 'Commander' : 'Indisponible');
      btn.type = 'button';
      if (!commandable) {
        btn.disabled = true;
      } else {
        btn.addEventListener('click', function () { ouvrirChoix(p); });
      }
      corps.appendChild(btn);

      art.appendChild(corps);
      return art;
    }

    // ── Choix des options ──

    /**
     * Fenêtre de choix.
     *
     * Le logo et la décoration sont fixés par l'organisation : l'usager ne
     * choisit que sa grandeur, et sa couleur s'il y en a plusieurs. C'est
     * volontairement le minimum de décisions possible.
     */
    function ouvrirChoix(p) {
      var choix = {};
      var fond = elem('div', 'updn-portail__fond');
      var boite = elem('div', 'updn-portail__boite');
      boite.setAttribute('role', 'dialog');
      boite.setAttribute('aria-modal', 'true');
      boite.setAttribute('aria-label', p.titre);

      var fermer = elem('button', 'updn-portail__fermer', '×');
      fermer.type = 'button';
      fermer.setAttribute('aria-label', 'Fermer');
      boite.appendChild(fermer);

      boite.appendChild(elem('h3', 'updn-portail__boite-titre', p.titre));
      var lignePrix = elem('p', 'updn-portail__boite-prix', prix(p.prixMin));
      boite.appendChild(lignePrix);

      var message = elem('p', 'updn-portail__boite-message');
      message.hidden = true;
      message.setAttribute('role', 'alert');

      var ajouter = elem('button', 'updn-btn updn-btn--plein updn-portail__ajouter', 'Ajouter au panier');
      ajouter.type = 'button';

      /** Variante correspondant aux choix actuels, ou null s'il en manque. */
      function varianteChoisie() {
        for (var i = 0; i < p.variantes.length; i++) {
          var v = p.variantes[i];
          var concorde = true;
          for (var j = 0; j < p.options.length; j++) {
            var nom = p.options[j].nom;
            if (v.options[nom] !== choix[nom]) { concorde = false; break; }
          }
          if (concorde) return v;
        }
        // Produit sans option porteuse de choix : une seule variante possible.
        return p.options.length === 0 ? p.variantes[0] : null;
      }

      /* Le nom est-il exigé ? Obligatoire toujours ; optionnel seulement coché. */
      function nomRequis() {
        if (!champNom) return false;
        return mode === 'obligatoire' || (caseNom && caseNom.checked);
      }
      function nomSaisi() {
        return champNom && champNom.value.trim().length > 0;
      }
      /* Facturé uniquement en mode optionnel : en obligatoire, c'est inclus. */
      function nomFacture() {
        return mode === 'optionnel' && caseNom && caseNom.checked && peutFacturer;
      }

      function rafraichir() {
        var v = varianteChoisie();
        var complet = p.options.every(function (o) { return choix[o.nom]; });

        if (!complet) {
          ajouter.disabled = true;
          ajouter.textContent = 'Choisissez vos options';
        } else if (!v || !v.disponible) {
          ajouter.disabled = true;
          ajouter.textContent = 'Cette combinaison n’est pas offerte';
        } else if (nomRequis() && !nomSaisi()) {
          ajouter.disabled = true;
          ajouter.textContent = 'Entrez le nom à broder';
        } else {
          ajouter.disabled = false;
          ajouter.textContent = 'Ajouter au panier';
          var total = Number(v.prix);
          if (nomFacture()) total += Number(supplement.montant);
          lignePrix.textContent = prix(total);
        }
      }

      p.options.forEach(function (option) {
        var groupe = elem('div', 'updn-portail__option');
        groupe.appendChild(elem('span', 'updn-portail__option-nom', option.nom));

        var liste = elem('div', 'updn-portail__pastilles');
        liste.setAttribute('role', 'group');
        liste.setAttribute('aria-label', option.nom);

        option.valeurs.forEach(function (valeur) {
          var b = elem('button', 'updn-portail__pastille', valeur);
          b.type = 'button';
          b.setAttribute('aria-pressed', 'false');

          // Une valeur qu'aucune variante disponible ne porte est montrée mais
          // barrée : voir qu'une grandeur existe et qu'elle est épuisée vaut
          // mieux que de la voir disparaître.
          var offerte = p.variantes.some(function (v) {
            return v.options[option.nom] === valeur && v.disponible;
          });
          if (!offerte) b.classList.add('est-epuisee');

          b.addEventListener('click', function () {
            choix[option.nom] = valeur;
            Array.prototype.forEach.call(liste.children, function (autre) {
              var actif = autre === b;
              autre.classList.toggle('est-choisie', actif);
              autre.setAttribute('aria-pressed', actif ? 'true' : 'false');
            });
            message.hidden = true;
            rafraichir();
          });
          liste.appendChild(b);
        });

        groupe.appendChild(liste);
        boite.appendChild(groupe);
      });

      /* ── Nom sur la manche ──────────────────────────────────────────────
         Trois modes, réglés produit par produit dans l'écran d'équipe :
           aucun       — rien ne s'affiche
           optionnel   — une case à cocher ; cochée, le champ apparaît et le
                         supplément s'ajoute comme ligne séparée
           obligatoire — le champ est là d'emblée, requis, sans supplément
                         (il est déjà dans le prix négocié)
         Le nom voyage sur la ligne du VÊTEMENT : c'est là que l'atelier le lit,
         à côté de la taille et de la couleur. */
      var champNom = null;
      var caseNom = null;
      var mode = p.modeNom || 'aucun';
      var peutFacturer = supplement && supplement.variante;

      if (mode === 'optionnel' && !peutFacturer) {
        // Sans variante de supplément configurée, un ajout au panier échouerait
        // sans explication. Mieux vaut ne pas proposer l'option du tout.
        mode = 'aucun';
      }

      if (mode !== 'aucun') {
        var blocNom = elem('div', 'updn-portail__option');

        if (mode === 'optionnel') {
          var etiquette = elem('label', 'updn-portail__case updn-portail__case--nom');
          caseNom = document.createElement('input');
          caseNom.type = 'checkbox';
          etiquette.appendChild(caseNom);
          etiquette.appendChild(elem('span', null,
            'Ajouter mon nom sur la manche (+ ' + prix(supplement.montant) + ')'));
          blocNom.appendChild(etiquette);
        } else {
          blocNom.appendChild(elem('span', 'updn-portail__option-nom', 'Nom sur la manche'));
        }

        var enveloppeNom = elem('div', 'updn-portail__nom-champ');
        champNom = document.createElement('input');
        champNom.type = 'text';
        champNom.maxLength = 20;
        champNom.className = 'updn-portail__quantite updn-portail__nom-saisie';
        champNom.placeholder = 'Prénom ou nom';
        champNom.id = 'portail-nom-manche';
        champNom.setAttribute('aria-label', 'Nom à broder sur la manche');
        enveloppeNom.appendChild(champNom);
        enveloppeNom.appendChild(elem('span', 'updn-portail__aide-nom',
          'Tel qu\'il sera brodé. 20 caractères au maximum.'));

        if (mode === 'optionnel') {
          enveloppeNom.hidden = true;
          caseNom.addEventListener('change', function () {
            enveloppeNom.hidden = !caseNom.checked;
            if (caseNom.checked) champNom.focus();
            rafraichir();
          });
        }
        champNom.addEventListener('input', rafraichir);
        blocNom.appendChild(enveloppeNom);
        boite.appendChild(blocNom);
      }

      var qte = elem('div', 'updn-portail__option');
      qte.appendChild(elem('label', 'updn-portail__option-nom', 'Quantité'));
      var champQte = document.createElement('input');
      champQte.type = 'number';
      champQte.min = '1';
      champQte.max = '50';
      champQte.value = '1';
      champQte.className = 'updn-portail__quantite';
      champQte.id = 'portail-quantite';
      qte.querySelector('label').setAttribute('for', 'portail-quantite');
      qte.appendChild(champQte);
      boite.appendChild(qte);

      boite.appendChild(message);
      boite.appendChild(ajouter);

      ajouter.addEventListener('click', function () {
        var v = varianteChoisie();
        if (!v) return;
        var n = Math.max(1, Math.min(50, parseInt(champQte.value, 10) || 1));

        ajouter.disabled = true;
        ajouter.textContent = 'Ajout en cours…';

        var nom = nomSaisi() ? champNom.value.trim() : '';
        ajouterAuPanier(v, n, p, nom, nomFacture()).then(function (ok) {
          if (ok) {
            ajouter.textContent = 'Ajouté ✓';
            setTimeout(function () { partir(); }, 700);
          } else {
            message.textContent = 'L’ajout au panier a échoué. Réessayez.';
            message.hidden = false;
            ajouter.disabled = false;
            ajouter.textContent = 'Ajouter au panier';
          }
        });
      });

      function partir() {
        document.removeEventListener('keydown', surTouche);
        fond.remove();
        document.body.style.overflow = '';
      }
      function surTouche(ev) { if (ev.key === 'Escape') partir(); }

      fermer.addEventListener('click', partir);
      fond.addEventListener('click', function (ev) { if (ev.target === fond) partir(); });
      document.addEventListener('keydown', surTouche);

      fond.appendChild(boite);
      document.body.appendChild(fond);
      // Empêche la page de défiler derrière la fenêtre — surtout sur téléphone.
      document.body.style.overflow = 'hidden';
      rafraichir();
      // Le focus part sur la fenêtre : au clavier, on ne se retrouve pas
      // toujours au début de la page derrière.
      (boite.querySelector('.updn-portail__pastille') || fermer).focus();
    }

    // ── Panier ──

    var boutiqueCourante = null;
    /* { montant, variante } — l'article compagnon facturé quand le nom est
       optionnel et coché. Le plan Basic ne permet pas de changer le prix d'une
       ligne de panier : le supplément est donc une ligne à part. */
    var supplement = null;

    /**
     * Ajout au panier.
     *
     * Deux marqueurs, et ce n'est pas une redondance :
     *   · `_portail` en propriété de LIGNE fait autorité — il survit à un panier
     *     qui mélangerait deux portails, ce que les attributs de panier ne font pas ;
     *   · l'attribut de panier, lui, s'affiche au checkout et sur la commande.
     * Le tag « portail:<slug> » est ensuite posé par le webhook orders/create,
     * côté serveur : c'est lui qui rend une campagne filtrable dans l'admin.
     *
     * Le souligné initial de `_portail` cache la propriété au client dans le
     * panier et à la caisse ; elle reste visible pour l'équipe sur la commande.
     */
    function ajouterAuPanier(variante, quantite, produit, nomManche, facturer) {
      var b = boutiqueCourante;
      if (!b) return Promise.resolve(false);

      var proprietes = { _portail: b.slug, _portail_nom: b.nom };
      /* Sans souligné : cette propriété-là DOIT se voir, au panier comme sur la
         commande. C'est ce que l'atelier brodera. */
      if (nomManche) proprietes['Nom sur la manche'] = nomManche;

      var articles = [{ id: variante.id, quantity: quantite, properties: proprietes }];

      /* La ligne de supplément. Elle porte le portail comme les autres — sinon
         elle échapperait au filtre Make — et un marqueur qui dit à l'atelier de
         ne pas la produire : ce n'est pas un vêtement. */
      if (facturer && supplement && supplement.variante) {
        articles.push({
          id: supplement.variante,
          quantity: quantite,
          properties: {
            _portail: b.slug,
            _supplement: 'nom-manche',
            'Nom brodé': nomManche
          }
        });
      }

      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: articles })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('ajout refusé')); })
        .then(function () {
          // L'attribut de panier n'est pas critique : s'il échoue, la propriété
          // de ligne suffit à retrouver la commande.
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { Portail: b.nom, _portail_slug: b.slug } })
          }).catch(function () { /* sans conséquence */ });
        })
        .then(function () {
          // Le thème écoute cet événement pour animer la pastille du panier.
          document.dispatchEvent(new CustomEvent('cart:updated'));
          rafraichirCompteurPanier();
          return true;
        })
        .catch(function () { return false; });
    }

    function rafraichirCompteurPanier() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (panier) {
          var bulles = document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]');
          Array.prototype.forEach.call(bulles, function (n) { n.textContent = panier.item_count; });
        })
        .catch(function () { /* cosmétique */ });
    }

    /**
     * Panier venu d'un autre portail ?
     *
     * On ne vide jamais le panier de quelqu'un sans le lui dire : on signale et
     * on propose. Deux portails dans une même commande partiraient en production
     * avec deux logos différents sans que rien ne le signale à l'atelier.
     */
    function verifierPanierMixte(boutique) {
      boutiqueCourante = boutique;

      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (panier) {
          var etrangers = (panier.items || []).filter(function (it) {
            var p = it.properties || {};
            // Une ligne sans portail vient de la boutique publique : elle compte
            // aussi comme étrangère, elle n'a rien à faire dans cette commande.
            return p._portail !== boutique.slug;
          });
          if (!etrangers.length) return;

          var avis = elem('div', 'updn-portail__avis');
          avis.setAttribute('role', 'status');
          avis.appendChild(elem('span', null,
            'Votre panier contient ' + etrangers.length +
            (etrangers.length > 1 ? ' articles qui ne viennent pas' : ' article qui ne vient pas') +
            ' de ce portail. Passez-les à la caisse séparément, ou videz votre panier.'));

          var vider = elem('button', 'updn-btn updn-btn--contour updn-portail__vider', 'Vider le panier');
          vider.type = 'button';
          vider.addEventListener('click', function () {
            vider.disabled = true;
            fetch('/cart/clear.js', { method: 'POST' })
              .then(function () { avis.remove(); rafraichirCompteurPanier(); })
              .catch(function () { vider.disabled = false; });
          });
          avis.appendChild(vider);

          if (volPrive) volPrive.insertBefore(avis, volPrive.children[2] || null);
        })
        .catch(function () { /* le panier reste consultable normalement */ });
    }

    // ── Reprise d'une session en cours ──

    var slugMemorise = lire(CLE_SLUG);
    if (slugMemorise && lire(CLE_JETON)) ouvrirPortail(slugMemorise);
  }

  function amorcer() {
    var noeuds = document.querySelectorAll('[data-updn-portail]');
    Array.prototype.forEach.call(noeuds, demarrer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', amorcer);
  } else {
    amorcer();
  }

  // L'éditeur de thème recharge une section sans recharger la page.
  document.addEventListener('shopify:section:load', amorcer);
})();
